webpackJsonp([44],{

/***/ 1124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(!_vm.isDetailRoute)?_c('div',[_c('header-page',{attrs:{"name":"promotions","title":_vm.$route.meta.title}}),_vm._v(" "),_c('div',{staticClass:"px-5 mt-4"},[_c('app-table',{staticClass:"my-5 is-not-selectable pb-4",attrs:{"name":"promotions","columns":_vm.columns,"current-page":_vm.currentPage,"rows":_vm.rows,"last-page":_vm.lastPage},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.title)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.description || 'Sin descripción')+" \n\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_c('v-chip',{attrs:{"color":props.row.isActive ? 'green' : 'grey',"text-color":"white","small":""}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.row.isActive ? 'Activo' : 'Inactivo')+"\n\t\t\t\t\t\t")])],1),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}],staticClass:"d-flex align-center"},[_c('app-tooltip-button',{attrs:{"color":"blue","icon":"collections","text":"Banners / Detalles"},on:{"click-icon":function($event){_vm.details(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"blue","icon":"edit","text":"Editar"},on:{"click-icon":function($event){_vm.edit(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"red","icon":"delete","text":"Eliminar"},on:{"click-icon":function($event){_vm.openModalConfirmation(props.row)}}}),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-switch',{staticClass:"mt-0 ml-2",attrs:{"slot":"activator","color":"green","hide-details":""},on:{"change":function($event){_vm.toggleStatus(props.row)}},slot:"activator",model:{value:(props.row.isActive),callback:function ($$v) {_vm.$set(props.row, "isActive", $$v)},expression:"props.row.isActive"}}),_vm._v(" "),_c('span',{staticClass:"text-center"},[_vm._v(_vm._s(props.row.isActive ? 'Desactivar' : 'Activar')+" promoción")])],1)],1)]}}])})],1),_vm._v(" "),_c('quick-actions',{attrs:{"actions":_vm.actions},on:{"open-modal":_vm.openModal}})],1):_vm._e(),_vm._v(" "),_c('app-confirmation-modal',{attrs:{"loading":_vm.loading,"show-modal":_vm.modalConfirmation.value},on:{"cancel":_vm.cancelModalConfirmation,"confirm":function($event){_vm.confirm()}}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_promotions_vue__ = __webpack_require__(873);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b013fe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_promotions_vue__ = __webpack_require__(1124);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_promotions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b013fe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_promotions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function actionToDo(item) {
	var action = item.link ? item.link : {
		width: item.width ? item.width : 0,
		title: item.text,
		code: item.code,
		active: item.active,
		open: true
	};
	var eventEmit = item.link ? 'to-link' : 'open-modal';
	this.$emit(eventEmit, action);
}

function setBorder(item) {
	var color = item.color === undefined ? '#9b9b9b' : item.color;
	return 'border-bottom: 4px solid ' + color;
}

function setMaxWidth(item) {
	var maxWidth = item.maxWidth ? item.maxWidth + 'px' : 'min-content';
	return 'max-width: ' + maxWidth;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'quick-actions',
	methods: {
		actionToDo: actionToDo,
		setBorder: setBorder,
		setMaxWidth: setMaxWidth
	},
	props: {
		actions: Array
	}
});

/***/ }),

/***/ 567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-confirmation-modal',
	props: {
		cancelText: {
			type: String,
			default: 'Cancelar'
		},
		confirmationText: {
			type: String,
			default: 'Eliminar'
		},
		loading: {
			default: false,
			type: Boolean
		},
		showModal: {
			type: Boolean,
			default: false
		},
		text: {
			type: String,
			default: 'Está seguro que desea eliminar este registro?'
		},
		width: {
			type: Number,
			default: 500
		}
	}
});

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_actions_vue__ = __webpack_require__(566);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33fee913_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_actions_vue__ = __webpack_require__(574);
function injectStyle (ssrContext) {
  __webpack_require__(572)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33fee913"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_actions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33fee913_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_actions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(573);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("3369894e", content, true);

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.actions[data-v-33fee913]{background:#fff;bottom:0;left:0;margin:0 auto;position:fixed;right:0;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.actions .actions-bar[data-v-33fee913]{border:1px solid #f1f3f7;border-radius:5px 5px 0 0;padding:0}.actions .actions-bar .action-content[data-v-33fee913]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;height:50px}.actions .actions-bar .action-content .action[data-v-33fee913],.actions .actions-bar .action-content[data-v-33fee913]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.actions .actions-bar .action-content .action[data-v-33fee913]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;height:40px;margin:0 10px;opacity:.3;padding:0;text-align:center;-webkit-transition-timing-function:cubic-bezier(.075,.82,.165,1);transition-timing-function:cubic-bezier(.075,.82,.165,1);-webkit-transition-duration:.5s;transition-duration:.5s;width:140px}.actions .actions-bar .action-content .action .action-txt[data-v-33fee913]{font-family:Opens_regular;font-size:10px;margin:0 0 0 5px;text-align:left}.actions .actions-bar .action-content .action[data-v-33fee913]:hover{margin-top:-20px;-webkit-transform:scale(1.1) translateY(-2px);transform:scale(1.1) translateY(-2px)}.actions .actions-bar .action-content .active[data-v-33fee913]{opacity:1}", "", {"version":3,"sources":["/opt/buildhome/repo/src/components/shared/quick-actions.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,sBAAyB,AACzB,uCAAwC,AACxC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,wCAAyC,AACzC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,0BAA6B,AAC7B,8CAA+C,AAC/C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,2CAA4C,AAC5C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,+CAAgD,AAChD,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,4CAA6C,AAC7C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,0BACE,gBAAkB,AAClB,SAAY,AACZ,OAAU,AACV,cAAiB,AACjB,eAAgB,AAChB,QAAW,AACX,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AACD,uCACI,yBAA0B,AAC1B,0BAA2B,AAC3B,SAAa,CAChB,AACD,uDACM,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAS9B,WAAa,CAClB,AACD,sHAVM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CA0BrC,AAvBD,+DACQ,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAS5B,eAAgB,AAChB,YAAa,AACb,cAAe,AACf,WAAa,AACb,UAAa,AACb,kBAAmB,AACnB,iEAAwE,AAChE,yDAAgE,AACxE,gCAAmC,AAC3B,wBAA2B,AACnC,WAAa,CACpB,AACD,2EACU,0BAA6B,AAC7B,eAAgB,AAChB,iBAAwB,AACxB,eAAiB,CAC1B,AACD,qEACQ,iBAAkB,AAClB,8CAA+C,AACvC,qCAAuC,CACtD,AACD,+DACQ,SAAW,CAClB","file":"quick-actions.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_bold';\n  src: url(\"/static/fonts/Lato-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_light';\n  src: url(\"/static/fonts/Lato-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n.actions[data-v-33fee913] {\n  background: white;\n  bottom: 0px;\n  left: 0px;\n  margin: 0px auto;\n  position: fixed;\n  right: 0px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.actions .actions-bar[data-v-33fee913] {\n    border: 1px solid #f1f3f7;\n    border-radius: 5px 5px 0 0;\n    padding: 0px;\n}\n.actions .actions-bar .action-content[data-v-33fee913] {\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      height: 50px;\n}\n.actions .actions-bar .action-content .action[data-v-33fee913] {\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        cursor: pointer;\n        height: 40px;\n        margin: 0 10px;\n        opacity: 0.3;\n        padding: 0px;\n        text-align: center;\n        -webkit-transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n                transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n        -webkit-transition-duration: 500ms;\n                transition-duration: 500ms;\n        width: 140px;\n}\n.actions .actions-bar .action-content .action .action-txt[data-v-33fee913] {\n          font-family: \"Opens_regular\";\n          font-size: 10px;\n          margin: 0px 0px 0px 5px;\n          text-align: left;\n}\n.actions .actions-bar .action-content .action[data-v-33fee913]:hover {\n        margin-top: -20px;\n        -webkit-transform: scale(1.1) translateY(-2px);\n                transform: scale(1.1) translateY(-2px);\n}\n.actions .actions-bar .action-content .active[data-v-33fee913] {\n        opacity: 1;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions"},[_c('div',{staticClass:"actions-bar"},[_c('div',{staticClass:"action-content"},_vm._l((_vm.actions),function(action,index){return _c('div',{key:index,staticClass:"action",class:{ active: action.active },style:(_vm.setBorder(action)),on:{"click":function($event){_vm.actionToDo(action)}}},[(action.img)?_c('img',{staticClass:"action-logo",attrs:{"src":action.img,"width":"20px","alt":action.text}}):_c('v-icon',{staticClass:"mb-2"},[_vm._v(_vm._s(action.icon))]),_vm._v(" "),_c('p',{staticClass:"action-txt",style:(_vm.setMaxWidth(action))},[_vm._v(_vm._s(action.text))])],1)}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_confirmation_modal_vue__ = __webpack_require__(567);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da054f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_confirmation_modal_vue__ = __webpack_require__(582);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_confirmation_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da054f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_confirmation_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"value":_vm.showModal,"width":_vm.width}},[_c('v-card',[_c('v-card-text',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.text)+"\n\t\t\t")]),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"primary","disabled":_vm.loading},on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.cancelText)+"\n\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"error","disabled":_vm.loading},on:{"click":function($event){_vm.$emit('confirm')}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.confirmationText)+"\n\t\t\t\t")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 873:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_quick_actions__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_app_tooltip_button__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_app_confirmation_modal__ = __webpack_require__(581);




var confirm = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var headers;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						headers = { Accept: '' + 'application/vnd.apiacl.v2+json' };
						_context.next = 4;
						return this.$http.delete('promotion/' + this.modalConfirmation.selectedRow.id, { headers: headers });

					case 4:
						this.showNotification('La promoción se eliminó correctamente');
						this.cancelModalConfirmation();
						this.loadData();
						_context.next = 12;
						break;

					case 9:
						_context.prev = 9;
						_context.t0 = _context['catch'](0);

						this.showError();

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 9]]);
	}));

	return function confirm() {
		return _ref3.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var params, headers, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.prev = 0;
						params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.params);
						headers = { Accept: '' + 'application/vnd.apiacl.v2+json' };
						_context2.next = 5;
						return this.$http.get('promotion', { params: params, headers: headers });

					case 5:
						response = _context2.sent;

						// Validamos según la estructura que definiste previamente[cite: 4]
						this.rows = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context2.next = 13;
						break;

					case 10:
						_context2.prev = 10;
						_context2.t0 = _context2['catch'](0);

						this.showError();

					case 13:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[0, 10]]);
	}));

	return function loadData() {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function openModal() {
	this.goTo('page-new-promotion');
}

function edit(_ref) {
	var id = _ref.id;

	this.goTo('page-edit-promotion', { params: { id: id } });
}

function details(_ref2) {
	var id = _ref2.id;

	this.goTo('page-promotion-details', { params: { id: id, codeProject: this.codeProject } });
}

function changePage(page) {
	this.currentPage = page;
	this.params.page = page;
	this.loadData();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadData();
}

function created() {
	this.loadData();
}

function data() {
	return {
		actions: [{
			id: 1,
			code: 'PROMO',
			text: 'Agregar Promoción',
			img: '',
			active: true
		}],
		columns: [{ id: 1, name: 'Título', checked: true, visible: true }, { id: 2, name: 'Descripción', checked: true, visible: true }, { id: 3, name: 'Estado', checked: true, visible: true }, { id: 4, name: '', checked: true, visible: true, flagVisible: true }],
		currentPage: 1,
		lastPage: 0,
		rows: [],
		loading: false,
		params: {
			page: 1,
			codeProject: this.codeProject
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-promotions',
	data: data,
	created: created,
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_4__components_shared_app_tooltip_button__["a" /* default */],
		quickActions: __WEBPACK_IMPORTED_MODULE_3__components_shared_quick_actions__["a" /* default */],
		appConfirmationModal: __WEBPACK_IMPORTED_MODULE_5__components_shared_app_confirmation_modal__["a" /* default */]
	},
	computed: {
		isDetailRoute: function isDetailRoute() {
			// Evalúa si estamos en la ruta hija de detalles[cite: 4]
			return this.$route.name && this.$route.name.includes('details');
		}
	},
	methods: {
		openModal: openModal,
		edit: edit,
		loadData: loadData,
		changePage: changePage,
		onSearch: onSearch,
		details: details,
		confirm: confirm,
		toggleStatus: function toggleStatus(row) {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var isActive, id, title, description, message, body, headers;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								isActive = row.isActive, id = row.id, title = row.title, description = row.description;
								message = isActive ? 'activó' : 'desactivó';
								body = {
									isActive: isActive,
									title: title,
									description: description
								};
								headers = { Accept: '' + 'application/vnd.apiacl.v2+json' };
								_context3.prev = 4;
								_context3.next = 7;
								return _this.$http.patch('promotion/' + id, body, { headers: headers });

							case 7:
								_this.showNotification('Se ' + message + ' la promoci\xF3n');
								_context3.next = 13;
								break;

							case 10:
								_context3.prev = 10;
								_context3.t0 = _context3['catch'](4);

								_this.showNotification('No se pudo cambiar el estado de la promoción', 'error');

							case 13:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this, [[4, 10]]);
			}))();
		}
	},
	props: {
		codeProject: {
			type: String
		}
	},
	watch: {
		$route: function $route(newVal) {
			if (newVal && newVal.name === 'page-promotions') {
				this.loadData();
			}
		},

		params: {
			handler: function handler(newVal) {
				if (newVal) this.loadData();
			},

			deep: true
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/44.62b8c33173ab4f6534c1.js